package one.healthium.ui.compose.components

import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.navigationBars
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.foundation.selection.selectable
import androidx.compose.foundation.selection.selectableGroup
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.theme.AppTheme

@Composable
fun AppNavigationRail(
    modifier: Modifier = Modifier,
    color: Color = AppTheme.navigationRailStyle.resolvedContainerColor,
    content: @Composable ColumnScope.() -> Unit
) {
    Surface(
        color = color,
        modifier = modifier
    ) {
        Column(
            modifier =
                Modifier.fillMaxHeight()
                    .windowInsetsPadding(WindowInsets.navigationBars)
                    .width(72.dp)
                    .selectableGroup()
                    .padding(vertical = 12.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center,
            content = content,
        )
    }
}

@Composable
fun ColumnScope.AppNavigationRailItem(
    modifier: Modifier = Modifier,
    selected: Boolean,
    icon: @Composable () -> Unit,
    label: @Composable () -> Unit = {},
    onClick: () -> Unit,
) {
    val interactionSource = remember { MutableInteractionSource() }

    Box(
        modifier
            .selectable(
                selected = selected,
                onClick = onClick,
                enabled = true,
                role = Role.Tab,
                interactionSource = interactionSource,
                indication = null,
            )
            .fillMaxWidth()
            .padding(vertical = 12.dp),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            val contentColor = if (selected) {
                AppTheme.navigationRailStyle.resolvedActiveLabelColor
            } else {
                AppTheme.navigationRailStyle.resolvedDefaultLabelColor
            }
            CompositionLocalProvider(LocalContentColor provides contentColor) {
                icon()
                CompositionLocalProvider(LocalTextStyle provides AppTheme.textStyles.secondary_12_400) {
                    label()
                }
            }
        }
    }
}
